<template>
  <div class="content">
    <!-- <myNav title="权限后台" textright="使用说明" @clickRight="goDesc"></myNav> -->
    <div class="gm-box">
      <div class="account">
        <input type="text" />
        <button @click="searchAccount">搜索</button>
      </div>

      <div class="game-info">
        <div class="game-detail">
          <img :src="state.ginfo.pic1" alt="" />
          <div class="game-name">{{ state.ginfo.gamename }}</div>
        </div>
        <div class="game-serve" @click="selectType('role')">
          <p>选择角色</p>
          <p>
            <span v-if="state.roleInfo.roleid">
              {{ state.roleInfo.rolename }}&nbsp;[{{ state.roleInfo.zonename }}]
            </span>
            <span v-else> 选择角色后才可解锁权限</span>
            <svg
              width="10"
              height="6"
              viewBox="0 0 10 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                id="Polygon 8"
                d="M5.70345 5.30376C5.31378 5.68944 4.68622 5.68944 4.29655 5.30376L0.666294 1.71074C0.0313219 1.08228 0.476353 0 1.36975 0H8.63026C9.52365 0 9.96868 1.08228 9.33371 1.71074L5.70345 5.30376Z"
                fill="#666666"
              />
            </svg>
          </p>
        </div>
      </div>

      <div class="gm-tool">
        <div class="tool-content">
          <img src="../../../assets/game/gmTool/select_title.png" alt="" />
          <ul class="gm-type">
            <li
              v-for="(item, index) in state.authList"
              :key="index + '-authlist'"
              :class="{ active: index === state.authFlag }"
              @click="selectAuth(item, index)"
            >
              <div class="left">
                <p>{{ item.tier_name }}</p>
                <p v-show="item.kt == 1">已解锁</p>
                <p v-show="item.kt == 0">未解锁</p>
              </div>
              <button v-show="item.kt == 1">已解锁</button>
              <button
                class="auth-lock"
                @click="goGmpay(item)"
                v-show="item.kt == 0"
              >
                立即解锁
              </button>
            </li>
          </ul>
          <p>解锁最高档位可获得以上所有权限</p>
        </div>
        <div class="select-content">
          <ul class="gm-select">
            <li @click="selectType('goods')">
              <p>选择物品</p>
              <p>
                {{ goodsType.item_name }}
                <svg
                  width="10"
                  height="6"
                  viewBox="0 0 10 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    id="Polygon 8"
                    d="M5.70345 5.30376C5.31378 5.68944 4.68622 5.68944 4.29655 5.30376L0.666294 1.71074C0.0313219 1.08228 0.476353 0 1.36975 0H8.63026C9.52365 0 9.96868 1.08228 9.33371 1.71074L5.70345 5.30376Z"
                    fill="#666666"
                  />
                </svg>
              </p>
            </li>
          </ul>
          <i></i>
          <van-field
            v-model="state.goodsnum"
            :placeholder="state.numInputplaceholder"
            type="digit"
            @update:model-value="updateNum"
            @click-input="inputFocus"
            :disabled="state.inputFlag"
          />
        </div>
        <p @click="debounceSendGoods">发放</p>
      </div>
      <toolPop
        @closePop="closePopup"
        @updateTypename="updateName"
        :cacheList="state.cacheList"
        :popShow="state.popShow"
        :selectIndex="selectIndex"
        :popload="state.poploadFlag"
      >
        <template v-slot:title>
          <h1>{{ state.poptitle }}</h1>
        </template>
        <template v-slot:search>
          <div class="search" v-if="state.typeflag == 'goods'">
            <van-field
              v-model="state.searchText"
              @update:model-value="updateSearch"
              placeholder="请输入搜索内容"
            />
            <p @click="goSearch">搜索</p>
          </div>
        </template>
        <template v-slot:role="slotProps">
          <div class="role-info" v-if="state.typeflag == 'role'">
            <h4>
              {{ slotProps.item.rolename }}&nbsp;[{{ slotProps.item.zonename }}]
            </h4>
            <p>小号:{{ slotProps.item.nickname }}</p>
            <p>角色ID:{{ slotProps.item.roleid }}</p>
          </div>
        </template>
        <template v-slot:goods="slotProps" v-if="state.typeflag == 'goods'">
          <h4 class="goods-info">{{ slotProps.data.item_name }}</h4>
        </template>
        <template v-slot:num="slotProps" v-if="state.typeflag == 'num'">
          <h4>{{ slotProps.data }}</h4>
        </template>
      </toolPop>
      <!-- <myLoading :load-flag="state.overlayShow"></myLoading> -->
      <toolBox @onAction="handleToolAction" v-if="!state.overlayShow"></toolBox>

      <div class="goods-log">
        <van-popup
          v-model:show="state.logPopFlag"
          position="bottom"
          round
          :style="{ height: '50%' }"
        >
          <div class="log-list">
            <li v-for="(item, index) in state.toolLog" :key="index">
              <!-- <li v-for="i in 10"> -->
              <p>{{ item.time }}:</p>
              <span>{{ item.msg }}</span>
            </li>
          </div>
        </van-popup>
      </div>
    </div>
  </div>
</template>
<script setup>
import { onActivated, reactive, ref, nextTick, onDeactivated } from "vue";
// import myLoading from "@/components/myLoading.vue";
import toolPop from "./toolPop.vue";
import router from "@/router";
import store from "@/store";
import toolBox from "./components/toolBox.vue";

const state = reactive({
  gid: "",
  ginfo: {
    gamename: "",
    id: "",
    pic1: "",
  },
  authFlag: 0,
  typeflag: "",

  roleInfo: {},
  rolelist: [],
  goodslist: [],

  authList: [],
  authType: {},
  overlayShow: true,
  popShow: false,

  searchText: "",
  goodsnum: "",
  inputFlag: true,
  numInputplaceholder: "请先选择物品",
  // 临时换存权限ID
  cacheAythtype: "",
  // 弹窗加载
  poploadFlag: false,

  // 工具日志
  toolLog: [], // 工具日志弹窗
  logPopFlag: false,
});

const searchAccount = () => {
  console.log("搜索账号");
};

const goodsType = ref({
  max_quantity: "",
}); // 物品类型

import { Local } from "@/utils/storage";
const goGmpay = (data) => {
  // 检验角色信息是否存在
  if (!state.roleInfo.roleid) {
    Toast("请先选择角色");
    return;
  }
  const gmPayInfo = Object.assign({}, state.ginfo, data, state.roleInfo);
  Local.set("gmPayInfo", gmPayInfo);

  router.push({
    path: "/gamedetail/gmPay",
    query: {
      gid: state.gid,
    },
  });
};
const goDesc = () => {
  console.log("跳转");
  router.push({
    path: "/public/webActivity",
    query: {
      url: "https://publich5.zhekoushenqi.com/#/newGmPermission",
      title: "使用说明",
    },
  });
};

const selectAuth = (item, index) => {
  state.authType = item;
  state.authFlag = index;
  goodsType.value = {};
  state.goodsnum = "";
  state.inputFlag = true;
  state.numInputplaceholder = "请先选择物品";
};

// 决定子组件弹窗显示内容
const selectIndex = ref(0); // 当前选中的索引
const selectType = async (item) => {
  // console.log("选择类型", item);
  state.typeflag = item;
  switch (item) {
    case "role":
      state.poptitle = "角色选择";
      state.cacheList = state.rolelist;
      if (state.roleInfo.roleid) {
        // 寻找state.roleInfo在state.rolelist中的索引
        const roleindex = state.rolelist.findIndex(
          (role) => role.roleid === state.roleInfo.roleid
        );
        // 如果找到了对应的索引，则更新selectIndex的值
        if (roleindex !== -1) {
          selectIndex.value = roleindex;
        }
      } else {
        selectIndex.value = 0;
      }
      break;
    case "goods":
      // 如果不是同一个权限打开，清空搜索框
      if (state.cacheAythtype != state.authType.id) {
        state.searchText = "";
      }

      state.poptitle = "物品选择";

      if (state.goodslist[state.authType.id]) {
        // console.log("当前道具已经存在");
        state.cacheList = state.goodslist[state.authType.id];
      } else {
        await getGmgoods();
      }

      if (goodsType.value.item_name != " ") {
        // 寻找state.roleInfo在state.rolelist中的索引
        const goodsindex = state.goodslist[state.authType.id].findIndex(
          (item) => item.item_name === goodsType.value.item_name
        );
        // 如果找到了对应的索引，则更新selectIndex的值
        if (goodsindex !== -1) {
          selectIndex.value = goodsindex;
        }
      } else {
        selectIndex.value = 0;
      }
      break;
    default:
      break;
  }
  state.popShow = true;
};

const closePopup = () => {
  state.popShow = false;
  state.cacheList = [];
};

const updateName = (data) => {
  // console.log("子组件触发父组件更新名称", data);
  state.cacheList = [];
  state.popShow = false;
  if (state.typeflag === "role") {
    state.roleInfo = data;
    // console.log("角色信息", data);
    // 根据角色id获取对应的权限问题
    getGmdetails();
    return;
  } else if (state.typeflag === "goods") {
    goodsType.value = data;
    state.inputFlag = false;
    state.numInputplaceholder = "请输入数量(默认为1)";
    state.goodsnum = "";
    // console.log("物品信息", goodsType.value);
    return;
  }
};

onActivated(() => {
  if (state.gid != getQueryString("gid")) {
    initInfo();
  }

  Local.remove("gmPayInfo");
  Local.remove("gmInfo");
  state.gid = getQueryString("gid");
  nextTick(() => {
    getGmdetails();
  });
});

const initInfo = () => {
  state.ginfo = {
    gamename: "",
    id: "",
    pic1: "",
  };
  state.authFlag = 0;
  state.typeflag = "";
  state.roleInfo = {};
  state.rolelist = [];
  state.overlayShow = true;
  goodsType.value = {};
  state.goodsnum = "";
  state.inputFlag = true;
  state.numInputplaceholder = "请先选择物品";
  state.cacheAythtype = "";
  state.popShow = false;
  state.toolLog = [];
  requestPool.quene = [];
  state.logPopFlag = false;
  state.goodslist = [];
};

import { getGmGame, getGmgoodsApi, gmGive } from "@/api/yzgame";
import { getQueryString } from "@/utils/location";
import { Toast, Dialog } from "vant";
// 获取gm相关数据
const getGmdetails = async (id) => {
  // console.log("state.roleInfo", state.roleInfo);
  try {
    let res = await getGmGame({
      username: store.state.username,
      gid: getQueryString("gid"),
      role_id: state.roleInfo.roleid,
      xiaohao: state.roleInfo.xh,
    });
    console.log("获取gm相关数据------", res.data);
    if (res.data.code == 1) {
      state.ginfo = res.data.data.ginfo;
      state.authList = res.data.data.tiers;
      state.rolelist = res.data.data.partlists;
      // 初始化权限选择
      selectAuth(state.authList[state.authFlag], state.authFlag);
      // console.log("GM基本信息-----", res.data.data);
    } else {
      Toast(res.data.msg);
    }
    state.overlayShow = false;
  } catch (error) {
    console.log("error", error);
  }
};

// 搜索物品数据
const goSearch = () => {
   // console.log("搜索物品数据");
  // 在对应的权限下搜索物品，state.authType.id为权限id,state.searchText为搜索内容,本地比对
  if (state.searchText) {
    if (state.goodslist[state.authType.id]) {
      state.cacheList = state.goodslist[state.authType.id].filter((item) =>
        item.item_name.includes(state.searchText)
      );
    }
    // console.log("搜索物品数据", state.cacheList);
  } else {
    Toast("请输入搜索内容");
  }
};
const updateSearch = (data) => {
  //输入框清空时恢复物品栏数据
  if (data == "") {
    state.cacheAythtype = undefined;
    state.cacheList = state.goodslist[state.authType.id];
  }
};

// 获取物品数据
const getGmgoods = async (data) => {
  state.popShow = true;
  state.poploadFlag = true;
  try {
    let res = await getGmgoodsApi({
      gid: getQueryString("gid"),
      tier_id: state.authType.id,
      name: data,
    });
    console.log("物品数据-----", res.data);
    if (res.data.code == 1) {
      state.cacheList = res.data.data;
      state.goodslist[state.authType.id] = res.data.data;
    } else {
      Toast(res.data.msg);
    }
    state.poploadFlag = false;
  } catch (error) {
    throw error;
  }
};

const inputFocus = () => {
  if (!goodsType.value.max_quantity) {
    Toast("请先选择物品");
  }
};
const updateNum = () => {
  if (state.goodsnum > goodsType.value.max_quantity) {
    Toast(`数量不能超过最大值${goodsType.value.max_quantity}`);
    state.goodsnum = goodsType.value.max_quantity;
  }
};
// 发放接口
/**
 * username  用户名
 * game_id  游戏id
 * role_id  角色id
 * number 数量
 * item_id  物品id
 * tier_id  权限id
 * item_name  物品名称
 * xiaohao 小号
 * zonid  区服zonid
 * type 物品类型
 */
import { debounce } from "@/utils/emojiToCode";
const sendGoods = async (goodsData) => {
  try {
    let data = {
      username: store.state.username,
      game_id: getQueryString("gid"),
      role_id: state.roleInfo.roleid,
      number: state.goodsnum ? state.goodsnum : 1,
      item_id: goodsData.item_id ? goodsData.item_id : goodsType.value.item_id,
      tier_id: state.authType.id,
      item_name: encodeURI(
        goodsData.item_name ? goodsData.item_name : goodsType.value.item_name
      ),
      xiaohao: state.roleInfo.xh,
      zoneid: state.roleInfo.zoneid,
      // type: goodsData.type ? goodsData.type : goodsType.value.type,
      type: goodsType.value.type,
      itemstype: goodsData.itemstype
        ? goodsData.itemstype
        : goodsType.value.itemstype,
    };
    let res = await gmGive(data);
    console.log("发放物品接口", res);
    if (res.data.code != 1) {
      requestPool.quene = [];
    }
    Toast(res.data.msg);
    // 获取当前时间
    let now = new Date();
    let timestamp = now.getTime();
    // 获取当前时间戳
    let date = new Date(timestamp);
    let hour = date.getHours();
    let minute = date.getMinutes();
    let second = date.getSeconds();
    let time = hour + ":" + minute + ":" + second;
    let logData = {
      time: time,
      msg: decodeURI(data.item_name) + res.data.msg,
    };
    state.toolLog.unshift(logData);
    // console.log("工具日志----", state.toolLog);
  } catch (error) {
    console.log("error", error);
  }
};
const debounceSendGoods = debounce(sendGoods, 500);

// -------------------- gm工具逻辑处理

// 定义父组件请求池逻辑
class RequestPool {
  constructor() {
    this.quene = []; // 请求队列
    this.isRequesting = false; // 是否正在请求
    this.intervalId = null; // 控制请求间隔
    this.shouldStopOnError = false; // 是否在请求失败时停止并清空队列
  }

  // 设置是否在请求失败时停止并清空队列
  stopOnError(value) {
    this.shouldStopOnError = value;
  }

  // 添加请求
  addRequest(request) {
    this.quene.push(request);
  }

  // 开始请求
  async startRequests() {
    console.log("开始请求------", this.isRequesting);
    // 开始请求之前，先清空之前的请求
    // this.quene = [];
    // this.stopRequests();
    if (this.isRequesting) return;
    this.isRequesting = true;
    this._processNextRequest();
  }

  // 停止请求
  stopRequests() {
    clearInterval(this.intervalId);
    this.isRequesting = false;
    this.quene = [];
  }

  // 处理队列中的请求
  async _processNextRequest() {
    console.log("处理下一个请求------");
    if (this.quene.length === 0) {
      this.isRequesting = false;
      return; // 请求队列为空，结束请求
    }

    const request = this.quene.shift(); // 取出队列中的第一个请求

    try {
      await request(); // 发送请求
      if (this.quene.length > 0) {
        this.intervalId = setTimeout(() => {
          this._processNextRequest();
        }, 5000); // 请求间隔为 5 秒
      }
    } catch (error) {
      console.error("请求失败, 错误信息:", error);

      if (this.shouldStopOnError) {
        console.error("发生错误，停止所有请求并清空队列");
        this.stopRequests(); // 中止所有请求并清空队列
      } else {
        console.log("请求失败，重试...");
        this.quene.unshift(request); // 请求失败，将请求重新加入队列
        this._processNextRequest(); // 继续处理下一个请求
      }
    }
  }
}

const handleToolAction = (tool) => {
  // 检查当前权限是否开通
  if (state.authType.kt == 0) {
    Toast("当前权限未解锁");
    return;
  }

  switch (tool.nature) {
    case "SENDTOOL":
      // handleSendTool(); // 发放道具
      openDialog(
        tool.nature,
        "当前操作会发放已选择权限内所有道具，请谨慎操作!",
        handleSendTool
      );
      break;
    case "STOPSEND":
      // stopSendTool(); // 停止发放
      openDialog(tool.nature, "是否终止所有自动发放道具任务?", stopSendTool);
      break;
    case "SELECTTEN":
      // handleSelectTen(); // 选中10次
      openDialog(
        tool.nature,
        "当前操作会把选中道具循环发放10次，请谨慎操作!",
        handleSelectTen
      );
      break;
    case "TOEND":
      // handleToEnd(); // 到结尾
      openDialog(
        tool.nature,
        "当前操作会把选中道具到结尾的道具全部发放，请谨慎操作!",
        handleToEnd
      );
      break;
    case "LATERTWENTY":
      // handleLaterTwenty(); // 后20项
      openDialog(
        tool.nature,
        "当前操作会把选中道具->以及之后的20个道具全部发放，请谨慎操作!",
        handleLaterTwenty
      );
      break;
    case "VIEWLOG":
      console.log("查看日志");
      handleViewLog(); // 查看日志
      break;
    case "CLEARLOG":
      console.log("清空日志");
      handleClearLog(); // 清空日志
      break;
    default:
      console.log("没有该工具类型");
  }
};

// 封装弹窗函数
const openDialog = (type, textContent, fn) => {
  Dialog.confirm({
    title: "注意!",
    cancelButtonText: "终止",
    confirmButtonText: "继续发放",
    message: textContent,
    // teleport: ".gm-box",
    className: "gm-dialog",
  })
    .then(() => {
      // on confirm
      if (type != "STOPSEND") {
        fn();
      }
    })
    .catch(() => {
      // on cancel
      if (type == "STOPSEND") {
        fn();
      }
    });
};

const requestPool = new RequestPool();
// 发放接口
const handleSendTool = () => {
  // console.log("此时的请求池状态-----", requestPool);
  requestPool.quene = [];
  state.goodslist.forEach((item) => {
    if (item.type == 1) {
      (async () => {
        // 将请求按顺序加入队列，确保请求是串行的
        await requestPool.addRequest(async () => {
          await sendGoods(item);
        }, item.id);
      })();
    }
  });
  requestPool.startRequests();
};
// 停止发放
const stopSendTool = () => {
  console.log("停止发放");
  requestPool.stopRequests();
};

// 处理选中10次
const handleSelectTen = () => {
  requestPool.quene = [];
  console.log("选中10次");
  // 模拟选中10次
  for (let index = 0; index < 10; index++) {
    requestPool.addRequest(() => sendGoods(goodsType.value), index);
  }
  // const selectedItems = []; // 假设这些是选中的道具
  requestPool.startRequests();
};

// 到结尾
const handleToEnd = () => {
  requestPool.quene = [];
  // 从当前项到结尾 ， 获取goodstype在goodslist中的索引
  console.log("到结尾----", goodsType.value);
  const startIndex = state.goodslist.findIndex(
    (item) => item.id === goodsType.value.id
  );
  const selectedItems = state.goodslist.slice(startIndex);
  selectedItems.forEach((item, index) => {
    if (item.type == 1) {
      goodsType.value = item;
      requestPool.addRequest(() => sendGoods(item), index);
    }
  });
  requestPool.startRequests();
};

// 后20项
const handleLaterTwenty = () => {
  requestPool.quene = [];
  // 从当前项到后20 ， 获取goodstype在goodslist中的索引，如果不足20个，则全部发放
  const startIndex = state.goodslist.findIndex(
    (item) => item.id === goodsType.value.id
  );
  const selectedItems = state.goodslist.slice(startIndex, startIndex + 20);
  selectedItems.forEach((item, index) => {
    if (item.type == 1) {
      goodsType.value = item;
      requestPool.addRequest(() => sendGoods(item), index);
    }
  });
  requestPool.startRequests();
};

// 查看日志
const handleViewLog = () => {
  // 查看日志
  console.log("查看日志");
  state.logPopFlag = true;
};

// 清空日志
const handleClearLog = () => {
  // 清空日志
  console.log("清空日志");
  state.toolLog = [];
};
</script>
<style scoped>
.nav {
  z-index: 99;
}
:deep(.van-nav-bar) {
  background-color: #f7f7f7;
}
.van-overlay {
  z-index: 9;
}
.content {
  min-height: 100vh;
  background-color: #f7f7f7;
  display: flex;
  flex-direction: column;
}
.gm-box {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.content .gm-box .account {
  width: 686px;
  height: 84px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  background-color: #fff;
  border-radius: 198px;
  margin-top: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: none;
  margin-bottom: 40px;
  padding: 0 32px;
}
.content .gm-box .account input {
  border: none;
  flex: 1;
  height: 84px;
}
.content .gm-box .account button {
  border: none;
  background: none;
  border-left: 2px solid #e5e5e5;
  padding-left: 20px;
}

.game-info {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  width: 686px;
  padding: 24px 32px;
  border-radius: 20px;
  background-color: #fff;
}

.game-info img {
  width: 120px;
  height: 120px;
  border-radius: 20px;
  margin-right: 24px;
}
.game-detail {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
}
.game-detail .game-name {
  color: #000;
  font-size: 36px;
  margin-bottom: 10px;
  max-width: 360px;
}
.game-detail button {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);

  width: 96px;
  height: 56px;
  background-color: #00d9c5;
  border-radius: 198px;
  border: none;
  color: #fff;
  font-size: 24px;
  font-weight: bold;
}

.game-info .game-serve {
  margin-top: 24px;
  color: #999999;
  font-size: 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.game-info .game-serve p:nth-of-type(2) {
  color: #333;
  display: flex;
  align-items: center;
}
.game-info .game-serve svg {
  margin-left: 18px;
}

.gm-tool {
  margin-top: 24px;
  flex: 1;
  padding: 28px 32px 0;
}
.gm-tool .tool-content {
  background: #fff;
  border-radius: 20px;
  padding: 32px;
}
.gm-tool .tool-content > img {
  width: 560px;
  height: 44px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 24px;
}
.gm-tool .gm-type {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.gm-type li {
  width: 300px;
  height: 155px;
  border-radius: 20px;
  background-color: rgba(0, 217, 197, 0.05);
  margin: 0 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px 0 32px;
  position: relative;
}
.gm-type li.active::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 4px solid #00d9c3;
  border-radius: 20px;
  z-index: 1;
}
.gm-type li p:nth-of-type(1) {
  color: #000;
  font-size: 24px;
}
.gm-type li p:nth-of-type(2),
.gm-type li p:nth-of-type(3) {
  color: #00d9c3;
  font-size: 20px;
  margin-top: 8px;
}
.gm-type li p:nth-of-type(3) {
  color: #af6e21;
}

.gm-type li button {
  width: 110px;
  height: 110px;
  border-radius: 20px;
  border: none;
  color: #fff;
  background-color: #d9d9d9;
}
.gm-type li button.auth-lock {
  background: linear-gradient(270deg, #00d9c3 0%, #20c2df 100%);
  white-space: wrap;
  padding: 0 14px;
  position: relative;
  z-index: 3;
}

.select-content {
  margin-top: 32px;
  background-color: #fff;
  border-radius: 20px;
}
.select-content i {
  width: 622px;
  height: 2px;
  background: #f2f2f2;
  display: block;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
.gm-tool :deep(.van-cell),
.gm-select li {
  width: 686px;
  height: 84px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
}
.gm-select p {
  display: flex;
  align-items: center;
}
.gm-select p svg {
  margin-left: 18px;
}
.gm-tool .tool-content > p:nth-of-type(1) {
  color: #00d9c3;
  text-align: center;
  font-size: 24px;
}
.gm-tool > p:last-child {
  margin-top: 44px;
  width: 686px;
  height: 96px;
  background: linear-gradient(90deg, #00d9c5 0%, #20c3de 100%);
  border-radius: 20px 20px 20px 20px;
  text-align: center;
  line-height: 96px;
  font-size: 36px;
  color: #fff;
  font-weight: 800;
  position: fixed;
  bottom: calc(80px + constant(safe-area-inset-bottom));
  bottom: calc(80px + env(safe-area-inset-bottom));
}

/* dialog弹窗 */
.gm-box :deep(.gm-dialog) {
  width: 546px;
  height: auto;
  padding-bottom: 24px;
}
.gm-box :deep(.van-dialog__header) {
  color: #ff5555;
  font-size: 36px;
  padding-top: 24px;
}
.gm-box :deep(.van-dialog__message) {
  padding-bottom: 24px;
}
.gm-box :deep(.gm-dialog .van-dialog__content .van-dialog__message--has-title) {
  color: #333;
  font-size: 28px;
  font-weight: bold;
}
.gm-box :deep(.van-dialog__footer) {
  justify-content: space-around;
}
.gm-box :deep(.gm-dialog button) {
  width: 236px !important;
  height: 80px;
  color: #fff;
  font-size: 28px;
  border-radius: 20px;
}
.gm-box :deep(.gm-dialog button:nth-of-type(1)) {
  background-color: #ff6666;
}
.gm-box :deep(.gm-dialog button:nth-of-type(2)) {
  background-color: #00d9c3;
}
/* 道具发放日志弹窗 */
.goods-log .log-list {
  padding-left: 32px;
  padding-top: 32px;
}
.goods-log li {
  display: flex;
  color: #999999;
  font-size: 28px;
}
.goods-log li span {
  margin-left: 8px;
  color: #ff6f38;
  font-size: 24px;
}
</style>
